import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
// import App from './App';

import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { HelmetProvider } from 'react-helmet-async';

import { RecoilRoot } from 'recoil';
import App from './App';
import Meta from 'component/Meta';

// Firebase 초기화
import './utils/firebase';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <HelmetProvider>
        <Meta />
        <RecoilRoot>
            <BrowserRouter>
                <QueryParamProvider adapter={ReactRouter6Adapter}>
                    <Suspense>
                        <App />
                    </Suspense>
                </QueryParamProvider>
            </BrowserRouter>
        </RecoilRoot>
    </HelmetProvider>
);

// root.render(
//     <StatusProvider>
//         <ThemeProvider>
//             <RouterProvider router={router} />
//         </ThemeProvider>
//     </StatusProvider>
// );
